import { RequestBasePageId, RequestBaseSet } from "@myapp/modules/fwcore/models/messages/request-base";
import { ResponseBasePage, ResponseBaseSet } from "@myapp/modules/fwcore/models/messages/response-base";
import { Module } from "../module";

export class RequestModule extends RequestBasePageId {

  licenseId?: string | null;
  userFilterId?: string | null;
  hasApi?: boolean | null;
  active?: boolean | null;
  includeHost?: boolean | null;

}

export class RequestModuleSet extends RequestBaseSet<Module>
{

}

export class ResponseModule extends ResponseBasePage<Module> {

}


export class ResponseModuleSet extends ResponseBaseSet<Module>{

}
